module.exports = __webpack_public_path__ + "static/media/logo-black.0600297e.png";